import { ExceptionGroup } from "~/pages/findings/Exceptions/types";

type GetExceptionLinkParams = {
  id: string;
  queryParams: URLSearchParams;
};

export function getExceptionLink({
  id,
  queryParams,
}: GetExceptionLinkParams): string {
  return `/space/findings/exceptions?${queryParams}&exceptionId=${id}`;
}

export const groupByExceptionType = (exceptionGroup: ExceptionGroup) => {
  const spaceCheckExceptions = exceptionGroup.exceptions.flatMap((e) =>
    e?.__typename === "SpaceCheckException" ? e : [],
  );
  const spaceAdvisoryExceptions = exceptionGroup.exceptions.flatMap((e) =>
    e?.__typename === "SpaceAdvisoryException" ? e : [],
  );
  const spaceCveExceptions = exceptionGroup.exceptions.flatMap((e) =>
    e?.__typename === "SpaceCveException" ? e : [],
  );
  const assetCheckExceptions = exceptionGroup.exceptions.flatMap((e) =>
    e?.__typename === "AssetCheckException" ? e : [],
  );
  const assetAdvisoryExceptions = exceptionGroup.exceptions.flatMap((e) =>
    e?.__typename === "AssetAdvisoryException" ? e : [],
  );
  const assetCveExceptions = exceptionGroup.exceptions.flatMap((e) =>
    e?.__typename === "AssetCveException" ? e : [],
  );
  const spaceFexExceptions = exceptionGroup.exceptions.flatMap((e) =>
    e?.__typename === "SpaceFexException" ? e : [],
  );
  const assetFexExceptions = exceptionGroup.exceptions.flatMap((e) =>
    e?.__typename === "AssetFexException" ? e : [],
  );

  return {
    spaceCheckExceptions,
    spaceAdvisoryExceptions,
    spaceCveExceptions,
    assetCheckExceptions,
    assetAdvisoryExceptions,
    assetCveExceptions,
    spaceFexExceptions,
    assetFexExceptions,
  };
};
